<template>
  <li v-if="$permissions.hasPermission('view_knowledge_base')" class="nav-group nav-group-title knowledge-base">
    <router-link :to="knowledgeBaseRoute">
      <i class="k-asset-icon fa-duotone fa-comments fa-swap-opacity" aria-hidden="true"></i><span>Knowledge Base</span>
    </router-link>
  </li>
</template>

<script>
import SidebarEntryMixin from '@mixins/sidebar-entry-mixin';

export default {
  mixins: [SidebarEntryMixin],

  data() {
    return {
      toggled: false,
    };
  },

  computed: {
    isVisible() {
      return this.$permissions.hasPermission('view_knowledge_base');
    },

    knowledgeBaseRoute() {
      return {
        name: 'knowledge_base_overview',
        query: {
          hide_answered: true,
          hide_closed_threads: true,
          hide_discussions: true,
        },
      };
    },
  },
};
</script>
